/* eslint-disable react/require-default-props */
import React from 'react';
import { useSelector } from 'react-redux';
import { Modal as ModalMui } from '@material-ui/core';
import { IconBell, IconClose } from '~/presentation/base/icons';
import { iStore } from '~/domain/interfaces/models';

import {
  BodyModal,
  Container,
  Content,
  HeaderModal,
  TitleHeaderModal,
} from './viewMedia/styles';

interface ModalProps {
  title: string;
  children: React.ReactNode;
  open: boolean;
  closeCallback?: () => void;
  hasFooter?: boolean;
}

export const Modal: React.FC<ModalProps> = ({
  title,
  children,
  open,
  closeCallback,
  hasFooter,
}) => {
  const { actionCancel } = useSelector((store: iStore) => store.message);

  const handleClose = () => {
    if (closeCallback) closeCallback();
    if (actionCancel) actionCancel();
  };

  return (
    <div>
      <ModalMui
        open={open}
        onClose={handleClose}
        style={{ marginBottom: hasFooter ? '120px' : '0px' }}
      >
        <Container>
          <Content>
            <HeaderModal>
              <TitleHeaderModal>{title}</TitleHeaderModal>
              <IconClose id="icon_close_modal" onClick={handleClose} />
            </HeaderModal>
            <BodyModal>{children}</BodyModal>
          </Content>
        </Container>
      </ModalMui>
    </div>
  );
};

export default Modal;
